import { RuleObject } from 'antd/lib/form';

const PROHIBITED_PHONES = [
  '912345678',
  '987654321',
  '123456789',
  '000000000',
  '123123123',
];

const allCharactersAreTheSame = (str: string) => {
  return (
    str.split('').every((char) => char === str[0]) ||
    str
      .slice(1)
      .split('')
      .every((char) => char === str[1])
  );
};

const isFakePhone = (value: string) => {
  const isDevelopmentEnvironment =
    process.env.NODE_ENV === 'development' ||
    window.location.href.includes('localhost') ||
    window.location.href.includes('.dev');
  if (isDevelopmentEnvironment) {
    return false;
  }
  return allCharactersAreTheSame(value) || PROHIBITED_PHONES.includes(value);
};

export const isPhoneValid = (phone: string) => {
  return !isFakePhone(phone) || phone === '';
};

const phoneValidator = (rule: RuleObject, value: string): Promise<void> => {
  if (isPhoneValid(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error('Ingrese un celular chileno válido!'));
};

export default phoneValidator;
